import React, { useContext, useRef, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { Cases, DELETE_CONFIRM, modalsName, options } from "../../../constant";
import ByteCardBuilderContext from "../../../context/BytecardBilderContext/ByteCardBuilderContext";
import { OpenModalCommonFunc, TostMessage } from "../../../utils";
import CardBuilderHeaderSection from "../../../common/cardBuilderHeaderSection";
import CommonPopup from "../../../Modals/commonPopup";
import GetWhatsAppLlinkPopup from "./GetWhatsAppLinkPopup";
import EditIcon from "@mui/icons-material/Edit";
import GetWhatsAppLinkParentPopup from "./GetWhatsAppLinkParentPopup";
import { FILE_UPLOAD_API } from "../apis/SliderApi/SliderApi";
import {
  convertRGBA,
  isCheckValue,
  isEmptyObject,
  randomStr,
  rgbColorCreate,
} from "../../../../utils/helper";
import { FILE_TYPE, ThemeNo, titleUpdateKey } from "../../../../constant";
import { IconButton } from "@material-ui/core";
import { Settings, Trash } from "react-feather";
import LoaderContext from "../../../../context/LoaderContext/LoaderContext";
import SimpleReactValidator from "simple-react-validator";
import GetWhatsAppLinkContext from "../../../context/GetWhatsAppLinkContext/GetWhatsAppLinkContext";
import {
  deleteGetWhatsAppLink,
  getGetWhatsAppLinkDetails,
  getWhatsAppLink,
  postGetWhatsAppLink,
  putUpdateGetWhatsAppLink,
  updateStatus,
} from "../apis/GetWhatsAppLinkApi/GetWhatsAppLinkApi";
import SettingGetWhatsAppParentPopup from "./SettingGetWhatsAppParentPopup";
import DeleteSection from "../../../common/DeleteSection";
import SettingMultiWebContext from "../../../../context/SettingMultiWebContext/SettingMultiWebContext";
import {
  GetWhatsAppLinkOneReset,
  GetWhatsAppLinkStyleOneSubFun,
  GetWhatsAppThemeOneFunction,
} from "./GetWhatsAppLinkStyleFunction";
import { uploadFileToSpaces } from "../../../apis/dashboardAPi/DeshboardApi";

const GetWhatsAppLink = (props) => {
  const {
    pageConfigDetails,
    webMasterDetail,
    getData,
    contentMapId,
    ByteMiniWeb_Dashboard,
    getLinkOnWhatsAppDetail,
    contentDetail,
  } = props;
  const { allPopupState, setAllPopupState } = useContext(
    ByteCardBuilderContext
  );
  const { setCloneAlignModal, setAlignFormData, setCloneFormData } = useContext(
    SettingMultiWebContext
  );
  const parentValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();
  const childValidator = useRef(new SimpleReactValidator());
  const {
    fromData,
    setFormData,
    formDataChild,
    setFormDataChild,
    id,
    setId,
    setIsEdit,
    isEdit,
    filter,
    apiDataOurTeam: apiDataImageParent,
    setApiDataOurTeam: setApiDataImageParent,
    setSkill,
    setGalleryImgId,
    setSettingFormData,
    settingFormData,
    isParent,
    setIsParent,
    childId,
    setChildId,
    navMapId,
    setBoxSection,
    boxSection,
    collId,
    setCollId,
    isBackgroundColor,
    setIsBackgroundColor,
    theme,
    setTheme,
    setImgShow,
    sectionPageName,
    setSectionPageName,
  } = useContext(GetWhatsAppLinkContext);
  const { setLoaderShow } = useContext(LoaderContext);

  /**
   * get whats app link parent list
   * @param {status} status
   */
  const getWhatsAppLinkParentList = async (
    parentId = null,
    isClose = false
  ) => {
    try {
      let paramObj = {};
      if (
        ((parentId && parentId !== null) ||
          (id && isClose === false && isParent === false)) &&
        isParent === false
      ) {
        paramObj["search"] = { parentId: parentId || id };
        setId(parentId || id);
        if (filter.length) {
          paramObj["search"] = { ...paramObj.search, title: filter };
        }
      } else {
        paramObj["search"] = { parentId: null };
      }
      const { data } = await getWhatsAppLink(paramObj);
      if (isCheckValue({ value: contentMapId })) {
        setCollId(contentMapId);
      }
      if (data.status === 200) {
        if (
          isParent === false &&
          ((parentId && parentId !== null) || id) &&
          isClose === false
        ) {
          setApiDataImageParent({
            ...apiDataImageParent,
            isLoading: false,
            data: data.payload.data.map((elem) => {
              return {
                id: elem?.title + elem?.getLinkOnWhatsAppId,
                Id: elem?.getLinkOnWhatsAppId,
                name: elem?.title,
                image: "",
                webId: elem?.webId,
                createdAt: elem?.createdAt,
                isActive: elem?.isActive,
              };
            }),
          });
          OpenModalCommonFunc(Cases.GET_WHATSAPP_LINK, setAllPopupState);
        } else if (parentId && parentId !== null) {
          OpenModalCommonFunc(Cases.GET_WHATSAPP_LINK, setAllPopupState);
          setApiDataImageParent({
            ...apiDataImageParent,
            isLoading: false,
            data: data.payload.data.map((elem) => {
              return {
                id: elem?.title + elem?.getLinkOnWhatsAppId,
                Id: elem?.getLinkOnWhatsAppId,
                name: elem?.title,
                image: elem?.image,
                webId: elem?.webId,
                createdAt: elem?.createdAt,
                isActive: elem?.isActive,
              };
            }),
          });
        } else {
          setApiDataImageParent({
            ...apiDataImageParent,
            isLoading: false,
            data: data.payload.data,
          });
        }
        if (isClose && isClose !== false) {
          setIsParent(false);
        }
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
    }
  };

  /**
   * item get whats app link enable disable api call
   * @param {getLinkOnWhatsAppId} getLinkOnWhatsAppId
   * @param {status} isActive
   */

  const handleChangeGetWhatsAppLink = async (getLinkOnWhatsAppId, isActive) => {
    try {
      let body = {
        getLinkOnWhatsAppId,
        isActive: isActive ? false : true,
      };
      const { data } = await updateStatus(body);
      if (data.status === 200) {
        ByteMiniWeb_Dashboard();
        TostMessage({ message: data, type: "success" });
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
    }
  };

  /**
   * file upload
   * @param {file} file
   */
  const imageUploadImages = async (file) => {
    // let formData = new FormData();
    // formData.append("type", FILE_TYPE.BYTE_SLIDER);
    // formData.append("file", file);
    setLoaderShow(true);
    const uniqueName = `${Date.now()}-${file.name}`;
    const formData = {
      type: FILE_TYPE.BYTE_SLIDER,
      file: uniqueName,
      fileType: file.type,
    };
    try {
      const { data } = await FILE_UPLOAD_API(formData);
      if (data.status === 200) {
        if (!data.payload?.uploadUrl) {
          TostMessage({ message: "Failed to get upload URL", type: "error" });
          setLoaderShow(false);
          return;
        }
        await uploadFileToSpaces(data.payload.uploadUrl, file);
        setFormDataChild((prev) => {
          return {
            ...prev,
            image: data.payload.baseUrl + data.payload.imageUrl,
            imageLink: data.payload.baseUrl + data.payload.imageUrl,
          };
        });
        setLoaderShow(false);
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };

  /**
   * create and update get whats app link
   */
  const submitForm = async () => {
    if (
      (isParent === false && childId >= -1 && isEdit) ||
      (id >= -1 && isEdit)
    ) {
      setLoaderShow(true);
      try {
        let formData = {};
        if (isParent && isParent !== false) {
          formData = {
            ...fromData,
            getLinkOnWhatsAppId: id,
            defaultCountry: fromData?.defaultCountry?.value || "",
            contentMapId: collId,
          };
        } else {
          formData = {
            ...formDataChild,
            parentId: id,
            navMapId,
            getLinkOnWhatsAppId: childId,
            contentMapId: collId,
          };
        }
        const { data } = await putUpdateGetWhatsAppLink(formData);
        if (data.status === 200) {
          if (isParent && isParent !== false) {
            ByteMiniWeb_Dashboard();
          } else {
            getWhatsAppLinkParentList();
          }
          getWhatsAppLinkParentList();
          emptyData();
          OpenModalCommonFunc(
            Cases.GET_WHATSAPP_LINK_PARENT,
            setAllPopupState,
            false
          );
          TostMessage({ message: data, type: "success" });
        }
      } catch (error) {
        TostMessage({ message: error, type: "error" });
        setLoaderShow(false);
      }
    } else {
      try {
        setLoaderShow(true);
        let formData = {};
        if (isParent && isParent !== false) {
          formData = {
            ...fromData,
            defaultCountry: fromData?.defaultCountry?.value || "",
            contentMapId: collId,
          };
        } else {
          formData = {
            ...formDataChild,
            parentId: id,
            navMapId,
            order: apiDataImageParent.data.length + 1,
            contentMapId: collId,
          };
        }
        const { data } = await postGetWhatsAppLink(formData);
        if (data.status === 200) {
          if (isParent && isParent !== false) {
            ByteMiniWeb_Dashboard();
          } else {
            getWhatsAppLinkParentList();
          }
          emptyData();
          OpenModalCommonFunc(
            Cases.GET_WHATSAPP_LINK_PARENT,
            setAllPopupState,
            false
          );
          TostMessage({ message: data, type: "success" });
        }
      } catch (error) {
        TostMessage({ message: error, type: "error" });
        setLoaderShow(false);
      }
    }
  };
  const handleSubmit = async (formValidationCondition) => {
    let validatorFields;
    if (formValidationCondition === "parentForm") {
      validatorFields = parentValidator.current;
    } else if (formValidationCondition === "childForm") {
      validatorFields = childValidator.current;
    }
    validatorFields.showMessages();

    if (validatorFields.allValid()) {
      try {
        // Process form data based on the formType
        if (formValidationCondition === "parentForm") {
          submitForm();
        } else if (formValidationCondition === "childForm") {
          submitForm();
        }
        validatorFields.hideMessages();
      } catch (error) {
        // Handle error for form submission
      }
    } else {
      // Force update to display validation messages
      forceUpdate({});
    }
  };

  /**
   * create and update get whats app link
   */

  const handleSubmitSetting = async (isRestore = false, isClose = true) => {
    if (id >= -1 && isEdit) {
      setLoaderShow(true);
      try {
        let newData;
        if (isRestore) {
          const isConfirm = window.confirm(
            "Are you sure want to restore style ?"
          );
          if (isConfirm) {
            newData = {
              styleRestore: true,
              getLinkOnWhatsAppId: id,
            };
          } else {
            setLoaderShow(false);
            return;
          }
        } else {
          if (+theme === ThemeNo.ThemeOne) {
            newData = GetWhatsAppLinkStyleOneSubFun({
              settingFormData,
              boxSection,
            });
            if (isBackgroundColor) {
              newData[".getlink-section"] = {
                ...newData?.[".getlink-section"],
                "background-color": settingFormData[".getlink-section"][
                  "background-color"
                ]
                  ? rgbColorCreate({
                    rgbString:
                      settingFormData[".getlink-section"]["background-color"],
                  })
                  : "",
              };
            }
          }
          const keysToRemove = [
            "bs1",
            "bs2",
            "bs3",
            "borderPx",
            "borderThik",
            "p1",
            "p2",
            "outPx",
            "outThik",
            "borderTopPx",
            "borderTopThik",
          ];
          function removeKeys(obj, keys) {
            for (const key in obj) {
              if (typeof obj[key] === "object") {
                removeKeys(obj[key], keys);
              } else if (keys.includes(key)) {
                delete obj[key];
              }
            }
          }
          removeKeys(newData, keysToRemove);
          newData = {
            style: newData,
            getLinkOnWhatsAppId: id,
          };
        }

        const { data } = await putUpdateGetWhatsAppLink(newData);
        if (data.status === 200) {
          getWhatsAppLinkParentList(null, true);
          if (isClose) {
            OpenModalCommonFunc(
              Cases.SETTING_GET_LINK_START_PARENT,
              setAllPopupState,
              false
            );
          }
          setLoaderShow(false);
          TostMessage({ message: data, type: "success" });
        }
      } catch (error) {
        TostMessage({ message: error, type: "error" });
        setLoaderShow(false);
      }
    }
  };

  /**
   * get data get whats app link
   * @param {id} getLinkOnWhatsAppId
   */
  const handleEditGetWhatsAppLink = async (getLinkOnWhatsAppId, isParent) => {
    try {
      setLoaderShow(true);
      const { data } = await getGetWhatsAppLinkDetails(getLinkOnWhatsAppId);
      if (data.status === 200) {
        let payload = data.payload.data;
        if (isParent) {
          setSectionPageName(payload.title);
          setId(getLinkOnWhatsAppId);
          setIsParent(true);
          setFormData({
            title: payload?.title || "",
            subTitle: payload?.subTitle || "",
            navMapId: payload?.navMapId || "",
            description: payload?.description || "",
            isTitleShow: payload?.isTitleShow ? payload?.isTitleShow : false,
            linkText: payload?.linkText || "",
            buttonText: payload?.buttonText || "",
            buttonValue: payload?.buttonValue || "",
            defaultCountry: payload?.defaultCountry
              ? options.find((elem) => elem.value === payload.defaultCountry)
              : "",
            webId: localStorage.getItem("webId"),
            style: payload?.style || "",
          });
          OpenModalCommonFunc(Cases.GET_WHATSAPP_LINK_PARENT, setAllPopupState);
        } else {
          setChildId(getLinkOnWhatsAppId);
          setIsParent(false);
          setFormDataChild({
            title: payload?.title || "",
            subTitle: payload?.subTitle || "",
            isTitleShow: payload?.isTitleShow ? payload?.isTitleShow : false,
            description: payload?.description || "",
            parentId: payload?.parentId || "",
            order: payload?.order || 1,
            webId: localStorage.getItem("webId"),
          });
          OpenModalCommonFunc(Cases.GET_WHATSAPP_LINK, setAllPopupState);
        }
        setIsEdit(true);
        TostMessage({ message: data, type: "success" });
        setLoaderShow(false);
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };

  /**
   * get setting data
   * @param {id} getLinkOnWhatsAppId
   */
  const handleChangeSettings = async (
    getLinkOnWhatsAppId,
    isThemeEdit = false
  ) => {
    try {
      setLoaderShow(true);
      setId(getLinkOnWhatsAppId);
      setSettingFormData((prev) => {
        return {
          ...prev,
          getLinkOnWhatsAppId,
        };
      });
      const { data } = await getGetWhatsAppLinkDetails(getLinkOnWhatsAppId);
      if (data.status === 200) {
        const themeCount = data?.payload?.data?.theme;
        setTheme(themeCount);
        setImgShow(true);
        let payload = data.payload.data;
        setSectionPageName(payload.title);
        if (
          +themeCount === ThemeNo.ThemeOne &&
          isEmptyObject(data?.payload?.data?.style)
        ) {
          setSettingFormData({ ...GetWhatsAppLinkOneReset });
          setBoxSection(false);
          setIsBackgroundColor(false);
        } else {
          if (payload.style?.[".getlink-section"]?.["width"]) {
            setBoxSection(true);
          }
          if (payload.style?.[".getlink-section"]?.["background-color"]) {
            setIsBackgroundColor(true);
          }
          let getStyle;
          if (+themeCount === 1) {
            getStyle = GetWhatsAppThemeOneFunction(payload);
          } else {
            getStyle = GetWhatsAppThemeOneFunction(payload);
          }
          setSettingFormData((prev) => {
            return {
              ...prev,
              ...getStyle,
            };
          });
        }
        if (!isThemeEdit) {
          OpenModalCommonFunc(
            Cases.SETTING_GET_LINK_START_PARENT,
            setAllPopupState
          );
          TostMessage({ message: data, type: "success" });
        }
        setIsEdit(true);
        setLoaderShow(false);
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };

  /**
   * delete get whats app link
   * @param {id} getLinkOnWhatsAppId
   */
  const handleDelete = async (getLinkOnWhatsAppId, isParent = false) => {
    let conformation = window.confirm(DELETE_CONFIRM);
    try {
      if (conformation) {
        setLoaderShow(true);
        const { data } = await deleteGetWhatsAppLink(getLinkOnWhatsAppId);
        if (data.status === 200) {
          if (isParent && isParent !== false) {
            // getWhatsAppLinkParentList(null, true);
            ByteMiniWeb_Dashboard();
          } else {
            getWhatsAppLinkParentList();
          }
          TostMessage({ message: data, type: "success" });
          setLoaderShow(false);
        }
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };

  /**
   * clear data
   */
  const emptyData = () => {
    setIsEdit(false);
    setIsParent(false);
    setBoxSection(false);
    setIsBackgroundColor(true);
    setChildId("");
    setFormData({
      title: "",
      subTitle: "",
      navMapId: "",
      description: "",
      isTitleShow: true,
      linkText: "",
      buttonText: "",
      buttonValue: "",
      defaultCountry: "",
      webId: localStorage.getItem("webId"),
      theme: 1,
      style: {
        ".getlink-section": {
          padding: "50px 0",
          "background-color": "rgb(238 238 238 / 100)",
        },
        ".getlink-section .section-title-area": {
          "margin-bottom": "50px",
        },
        ".getlink-section .section-title-area .section-subtitle": {
          "font-size": "16px",
          "font-weight": "600",
          color: "rgb(255 73 124 / 100)",
          "background-color": "rgb(255 73 124 / 0.2)",
          padding: "5px 20px",
          p1: "5px",
          p2: "20px",
          "border-radius": "15px",
          display: "inline-block",
          "margin-bottom": "15px",
        },
        ".getlink-section .section-title-area .section-title": {
          "font-size": "44px",
          "font-weight": "600",
          color: "rgb(0 0 0 / 100)",
        },
        ".getlinksbox .section-note": {
          "font-size": "18px",
          "font-weight": "500",
          color: "rgb(153 153 153 / 100)",
        },
        ".getlinksbox": {
          "background-color": "rgb(255 255 255 / 100)",
          padding: "40px 40px",
          p1: "40px",
          p2: "40px",
          "border-radius": "15px",
          border: "1px solid rgb(255 255 255 / 100)",
          borderPx: "1px",
          borderThik: "solid",
          borderColor: "rgb(255 255 255 / 100)",
          "border-top": "3px solid rgb(255 73 124 / 100)",
          borderTopPx: "3px",
          borderTopThik: "solid",
          borderTopColor: "rgb(255 73 124 / 100)",
          "box-shadow": "5px 5px 15px rgb(0 0 0 / 0.09)",
          bs1: "5px",
          bs2: "5px",
          bs3: "15px",
          shadowColor: "rgb(0 0 0 / 0.09)",
        },
        ".getlinksbox .form-control": {
          width: "100%",
          "margin-bottom": "10px",
          "background-color": "rgb(242 247 255 / 100)",
          border: "2px solid rgb(238 238 238 / 100)",
          borderPx: "2px",
          borderThik: "solid",
          borderColor: "rgb(238 238 238 / 100)",
          "border-radius": "4px",
          "font-size": "16px",
          appearance: "auto",
          outline: "0px solid rgb(255 255 255 / 100)",
          outPx: "0px",
          outThik: "solid",
          outcolor: "rgb(255 255 255 / 100)",
        },
        ".getlink-section .getlinksbox .btn": {
          color: "rgb(255 255 255 / 100)",
          "background-color": "rgb(255 73 124 / 100)",
        },
      },
    });
    setSkill([{ id: randomStr(2), skill: "", parentageOfSkill: "" }]);
    setGalleryImgId("");
    setFormDataChild({
      title: "",
      subTitle: "",
      description: "",
      isTitleShow: true,
      order: 1,
      webId: localStorage.getItem("webId"),
      navMapId: "",
    });
    setLoaderShow(false);
    setSettingFormData({
      ".getlink-section": {
        padding: "50px 0",
        "background-color": "rgb(238 238 238 / 100)",
      },
      ".getlink-section .section-title-area": {
        "margin-bottom": "50px",
      },
      ".getlink-section .section-title-area .section-subtitle": {
        "font-size": "16px",
        "font-weight": "600",
        color: "rgb(255 73 124 / 100)",
        "background-color": "rgb(255 73 124 / 0.2)",
        padding: "5px 20px",
        p1: "5px",
        p2: "20px",
        "border-radius": "15px",
        display: "inline-block",
        "margin-bottom": "15px",
      },
      ".getlink-section .section-title-area .section-title": {
        "font-size": "44px",
        "font-weight": "600",
        color: "rgb(0 0 0 / 100)",
      },
      ".getlinksbox .section-note": {
        "font-size": "18px",
        "font-weight": "500",
        color: "rgb(153 153 153 / 100)",
      },
      ".getlinksbox": {
        "background-color": "rgb(255 255 255 / 100)",
        padding: "40px 40px",
        p1: "40px",
        p2: "40px",
        "border-radius": "15px",
        border: "1px solid rgb(255 255 255 / 100)",
        borderPx: "1px",
        borderThik: "solid",
        borderColor: "rgb(255 255 255 / 100)",
        "border-top": "3px solid rgb(255 73 124 / 100)",
        borderTopPx: "3px",
        borderTopThik: "solid",
        borderTopColor: "rgb(255 73 124 / 100)",
        "box-shadow": "5px 5px 15px rgb(0 0 0 / 0.09)",
        bs1: "5px",
        bs2: "5px",
        bs3: "15px",
        shadowColor: "rgb(0 0 0 / 0.09)",
      },
      ".getlinksbox .form-control": {
        width: "100%",
        "margin-bottom": "10px",
        "background-color": "rgb(242 247 255 / 100)",
        border: "2px solid rgb(238 238 238 / 100)",
        borderPx: "2px",
        borderThik: "solid",
        borderColor: "rgb(238 238 238 / 100)",
        "border-radius": "4px",
        "font-size": "16px",
        appearance: "auto",
        outline: "0px solid rgb(255 255 255 / 100)",
        outPx: "0px",
        outThik: "solid",
        outcolor: "rgb(255 255 255 / 100)",
      },
      ".getlink-section .getlinksbox .btn": {
        color: "rgb(255 255 255 / 100)",
        "background-color": "rgb(255 73 124 / 100)",
      },
    });
  };

  const handleAlignAndCloneSection = ({ isClone = false }) => {
    if (isClone) {
      setCloneAlignModal((prev) => {
        return {
          ...prev,
          cloneModal: true,
        };
      });
      setCloneFormData((prev) => {
        return {
          ...prev,
          contentMapId,
          pageConfigDetailsLabel: pageConfigDetails[0]?.label,
          contentDetailName: contentDetail.name,
        };
      });
    } else {
      setCloneAlignModal((prev) => {
        return {
          ...prev,
          alignModal: true,
        };
      });
      setAlignFormData((prev) => {
        return {
          ...prev,
          contentMapId,
          label: pageConfigDetails[0]?.label,
        };
      });
    }
  };

  return (
    <>
      <Col xl="12 box-col-6" md="12">
        <Card className="ecommerce-widget mt-4 cardHover">
          <CardBody
            className="support-ticket-font box-border-div"
            style={{ padding: "20px" }}
          >
            <Row>
              <CardBuilderHeaderSection
                addBtnTitle={pageConfigDetails[0]?.label}
                name={pageConfigDetails[0]?.label}
                isAdd={!getLinkOnWhatsAppDetail && true}
                mainEditSection={true}
                ByteMiniWeb_Dashboard={ByteMiniWeb_Dashboard}
                pageId={pageConfigDetails[0]?.pageId}
                openModal={() => {
                  OpenModalCommonFunc(
                    Cases.GET_WHATSAPP_LINK_PARENT,
                    setAllPopupState
                  );
                  setSectionPageName(modalsName.GET_WHATSAPP_LINK_PARENT);
                  emptyData();
                  setIsParent(true);
                  setCollId(contentMapId);
                }}
                isCloneSection={true}
                isAlignSection={true}
                handleAlignAndCloneSection={handleAlignAndCloneSection}
              />
              {getLinkOnWhatsAppDetail && (
                <Col xl="12 xl-50 box-col-6" md="6">
                  <Card className="ecommerce-widget mb-0">
                    <CardBody
                      className="support-ticket-font"
                      style={{ padding: "20px" }}
                    >
                      <div className="col-12">
                        <CardBuilderHeaderSection
                          name={getLinkOnWhatsAppDetail?.title}
                          checked={getLinkOnWhatsAppDetail?.isActive}
                          switchToggle={true}
                          id={getLinkOnWhatsAppDetail?.getLinkOnWhatsAppId}
                          handleChange={handleChangeGetWhatsAppLink}
                        />
                      </div>
                      <div className="d-flex justify-content-end ">
                        <IconButton
                          edge="start"
                          color="inherit"
                          style={{ marginLeft: "5px" }}
                          onClick={() => {
                            setSectionPageName(getLinkOnWhatsAppDetail.title);
                            handleEditGetWhatsAppLink(
                              getLinkOnWhatsAppDetail.getLinkOnWhatsAppId,
                              true
                            );
                            setCollId(contentMapId);
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          edge="start"
                          color="inherit"
                          style={{ marginLeft: "5px" }}
                          onClick={() =>
                            handleDelete(
                              getLinkOnWhatsAppDetail.getLinkOnWhatsAppId,
                              true
                            )
                          }
                        >
                          <Trash />
                        </IconButton>
                        <IconButton
                          edge="start"
                          color="inherit"
                          style={{ marginLeft: "5px" }}
                          onClick={() => {
                            handleChangeSettings(
                              getLinkOnWhatsAppDetail.getLinkOnWhatsAppId
                            );
                          }}
                        >
                          <Settings />
                        </IconButton>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              )}
              <DeleteSection
                ByteMiniWeb_Dashboard={ByteMiniWeb_Dashboard}
                pageId={pageConfigDetails[0]?.pageId}
              />
            </Row>
          </CardBody>
        </Card>
      </Col>
      <CommonPopup
        open={allPopupState.getWhatsAppLinkChildPopup}
        close={() => {
          OpenModalCommonFunc(Cases.GET_WHATSAPP_LINK, setAllPopupState, false);
          setIsParent(false);
          getWhatsAppLinkParentList(null, true);
        }}
        apiCall={getWhatsAppLinkParentList}
        modalName={
          sectionPageName ? sectionPageName : modalsName.GET_WHATSAPP_LINK
        }
        modalCase={Cases.GET_WHATSAPP_LINK}
        handleSubmit={handleSubmit}
        validationForm={"childForm"}
        emptyData={emptyData}
        inputData={fromData}
        edit={false}
        oldTitle={titleUpdateKey.isGallery}
        label={titleUpdateKey.Certificates}
        getData={getData}
        content={
          <GetWhatsAppLlinkPopup
            handleChangeStatus={handleChangeGetWhatsAppLink}
            handleEdit={handleEditGetWhatsAppLink}
            imageUpload={imageUploadImages}
            emptyData={emptyData}
            simpleValidator={childValidator}
            webMasterDetail={webMasterDetail}
            handleDelete={handleDelete}
          />
        }
      />

      {/* item get whats app link popup */}
      <CommonPopup
        open={allPopupState.getWhatsAppLinkPopup}
        close={() => {
          OpenModalCommonFunc(
            Cases.GET_WHATSAPP_LINK_PARENT,
            setAllPopupState,
            false
          );
          setIsParent(false);
        }}
        modalName={
          sectionPageName
            ? sectionPageName
            : modalsName.GET_WHATSAPP_LINK_PARENT
        }
        modalCase={Cases.GET_WHATSAPP_LINK_PARENT}
        handleSubmit={handleSubmit}
        validationForm={"parentForm"}
        emptyData={emptyData}
        inputData={formDataChild}
        edit={false}
        content={
          <GetWhatsAppLinkParentPopup simpleValidator={parentValidator} />
        }
      />

      {/* setting Service Counter parent popup */}
      <CommonPopup
        open={allPopupState.getLinkStartSettingPopup}
        close={() =>
          OpenModalCommonFunc(
            Cases.SETTING_GET_LINK_START_PARENT,
            setAllPopupState,
            false
          )
        }
        modalName={
          sectionPageName
            ? sectionPageName
            : modalsName.SETTING_GET_LINK_START_PARENT
        }
        modalCase={Cases.SETTING_GET_LINK_START_PARENT}
        handleSubmit={handleSubmitSetting}
        emptyData={emptyData}
        // inputData={formDataChild}
        edit={false}
        content={
          <SettingGetWhatsAppParentPopup
            handleSubmitSetting={handleSubmitSetting}
            handleChangeSettings={handleChangeSettings}
          />
        }
      />
    </>
  );
};

export default GetWhatsAppLink;
